import { Dispatch, SetStateAction } from "react";
import { FormCheckbox } from "semantic-ui-react";

export const NewCheckboxFormComponent = (props: {
  props: NewCheckboxFormComponentProps;
  data: any;
  setData: Dispatch<SetStateAction<any>>;
}) => {
  return (
    <FormCheckbox
      label={props.props.label}
      checked={props.data[props.props.key]}
      onChange={(event, data) => {
        const newValues = { ...props.data };
        newValues[props.props.key] = data.checked;
        props.setData(newValues);
      }}
    />
  );
};

export type NewCheckboxFormComponentProps = {
  type: "checkbox";
  label: string;
  key: string;
};
